import { toNumber, normalizeSelectInput, localizeNumber } from "../../../../helpers";
import ibsStore from "../../../Stores/IbsSurveyStore"
import { mapToDropdownOption } from "../../../../ibsHelper";
import { SelectCombosIBS, NumberFormat } from "../../../../Enums/constants";
import { saveValueNew, updateMandateInfoSingleCtrl } from "../../../../control";
import { renderDeleteIconBtn, isNumField } from "../../../../Helpers/TableHelper";
import { columnCalculation } from "../../../../Helpers/TableCalculationHelper";
import { formatNumber } from "../../../../Helpers/General/FormatHelper";
import { toJS } from "mobx";

export function handleHOTChangeLtdPartnership(table, rowNum, qId, oldValue, newValue, props, referenceToTable) {
    if (rowNum !== undefined && rowNum !== null
        && qId !== undefined && qId !== null
        && newValue != oldValue
        && newValue !== 'undefined') { // TODO something weird happens when this is changed to newValue !== oldValue

        let normalizedNewValue = newValue;

        if (isNumField(table, qId, props)) {
            normalizedNewValue = toNumber(newValue);
            if (Number.isNaN(normalizedNewValue)) {
                // It's a number field, but newValue is not a number
                // just save an empty value
                normalizedNewValue = null;
            }
        }
      
        let rowId, result;
        rowId = referenceToTable[rowNum].RowID //the rowId 
        result = ibsStore.allTableResponses[props.tableName].findIndex(row => row.RowID === rowId); //where it is saved on frontend

        if (qId === "IsInCommitmentPeriod") { //lmtd partnerships
            normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.YES_NO)
        }
        else if (qId === "PrivateEquityRegionName") {
            ibsStore.allTableResponses[props.tableName][result][qId] = newValue;
            normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.PRIVATE_EQUITY_REGIONS)
            qId = "PrivateEquityRegionID"
        }
        else if (qId === "PrivateEquityTypeName") {
            ibsStore.allTableResponses[props.tableName][result][qId] = newValue;
            normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.PRIVATE_EQUITY_TYPES)
            qId = "PrivateEquityTypeID"
        }
        else if (qId === "FeeBasisDuringCommitmentTypeName") {
            ibsStore.allTableResponses[props.tableName][result][qId] = newValue;
            normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.PRIVATE_EQUITY_COMMITMENT_TYPES)
            qId = "FeeBasisDuringCommitmentTypeID"
        }
        else if (qId === "FeeBasisPostCommitmentTypeName") {
            ibsStore.allTableResponses[props.tableName][result][qId] = newValue;
            normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.PRIVATE_EQUITY_COMMITMENT_TYPES)
            qId = "FeeBasisPostCommitmentTypeID"
        }
        else if (qId == "DataYear") {
            let mandateId = referenceToTable[rowNum].MandateID;
            updateMandateInfoSingleCtrl("VintageYear", newValue, mandateId)
        }
       
        ibsStore.allTableResponses[props.tableName][result][qId] = normalizedNewValue;

        let rulesSet = saveValueNew(qId, normalizedNewValue, { tableName: props.tableName, rowId })

    }
}

export function renderPrivateEquityTotalRow(props) {
    let totalRow = {};
    totalRow['OriginalCommitmentMil'] = formatNumber(NumberFormat.MONEYMILLION, columnCalculation("OriginalCommitmentMil", true, props));
    totalRow['UnreturnedInvestmentCapMil'] = formatNumber(NumberFormat.MONEYMILLION, columnCalculation("UnreturnedInvestmentCapMil", true, props));
    totalRow['NetAssetValueMil'] = formatNumber(NumberFormat.MONEYMILLION, columnCalculation("NetAssetValueMil", true, props));
    return totalRow;
}
export function LtdPartnershipCellRenderer(instance, td, row, col, prop, value, cellProperties, referenceToTable,props) {
    if (prop == "PartnershipName" || prop == "NetAssetValueMil") { //Ltd Partnerships
        if (referenceToTable && referenceToTable[row]?.MandateID != null) {
            cellProperties.readOnly = true
            td.className = td.className + " readOnlyCell"
        }
      
    }
    if (prop === "del" && td.id !== "undefined") {
        renderDeleteIconBtn(td, row, props, referenceToTable)
    }
   
    return cellProperties;

}

export function beforeKeyDownPrivateEquity(e, editor) {
    try {
        // Prevent people from entering invalid dates in DataYear
        if (editor.prop === "DataYear" &&
            ((!/[0-9]/.test(e.key) || editor.TEXTAREA.value.length >= 4)
                && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Backspace')) {
            e.preventDefault()
        }
    }
    catch { }
}

export function handleLtdPartnershipsData(props, referenceToTable, listOfHeaderRows, dataObj) {
    let ltdPartnerships = createLtdPartnershipsData(props, referenceToTable, listOfHeaderRows, dataObj)
    let data = ltdPartnerships[0]
    let headers = ltdPartnerships[1]
    referenceToTable = ltdPartnerships[2]

    return [data, referenceToTable, headers]
}
export function createLtdPartnershipsData(props, referenceToTable, listOfHeaderRows, dataObj) {
    var rawData = ibsStore.allTableResponses[props.tableName]
    if (rawData == [] || typeof rawData === "undefined" || rawData === undefined) return {};
    referenceToTable = rawData
    if (rawData!==null) dataObj = rawData.slice();

    dataObj.forEach((elem) => {
        if (elem.hasOwnProperty('OriginalCommitmentMil')) {
            elem.OriginalCommitmentMil = localizeNumber(elem.OriginalCommitmentMil);
        }
        if (elem.hasOwnProperty('UnreturnedInvestmentCapMil')) {
            elem.UnreturnedInvestmentCapMil = localizeNumber(elem.UnreturnedInvestmentCapMil);
        }
        if (elem.hasOwnProperty('FeePercentCommitment')) {
            elem.FeePercentCommitment = localizeNumber(elem.FeePercentCommitment);
        }
        if (elem.hasOwnProperty('NetAssetValueMil')) {
            elem.NetAssetValueMil = localizeNumber(elem.NetAssetValueMil);
        }
        if (elem.hasOwnProperty('FeePercentInvestedCap')) {
            elem.FeePercentInvestedCap = localizeNumber(elem.FeePercentInvestedCap);
        }
        if (elem.hasOwnProperty('CarriedInterestPercent')) {
            elem.CarriedInterestPercent = localizeNumber(elem.CarriedInterestPercent);
        }
        if (elem.hasOwnProperty('HurdleRatePercent')) {
            elem.HurdleRatePercent = localizeNumber(elem.HurdleRatePercent);
        }
        if (elem.hasOwnProperty('IsInCommitmentPeriod')) {
            elem.IsInCommitmentPeriod = mapToDropdownOption(elem.IsInCommitmentPeriod, SelectCombosIBS.YES_NO) ?? elem.IsInCommitmentPeriod;
        }

    });

    // Also handle the total row, HERE?
    let includeTotalRow = props.includeTotalRow;
    if (includeTotalRow) {
        let totalRow = {};
        totalRow = props.renderTotalRow(props);
        if (Object.keys(totalRow).length > 0) {
            dataObj.push(totalRow);
            listOfHeaderRows.push(dataObj.length - 1);
        }
    }
    
    //{ data: 'PartnershipName' },
    //{ data: 'PrivateEquityTypeName', className: "htLeft", type: 'dropdown', source: ['', 'Diversified', 'LBO', 'Venture Cap.', 'Expansion Cap.', 'Mezzanine', 'Distressed Debt', 'Energy', 'Other', 'Real Estate', 'Infrastructure', 'Timberland', 'Direct Lending'] },
    //{ data: 'PrivateEquityRegionName', className: "htLeft", type: 'dropdown', source: ['', 'U.S.', 'Canada', 'Europe', 'Asia - Pacific', 'Other', 'Global'] },
    //{ data: 'DataYear' },
    //{ data: 'IsInCommitmentPeriod', type: 'dropdown', source: getOptionsArray(SelectCombosIBS.YES_NO) },
    //{ data: 'OriginalCommitmentMil' },
    //{ data: 'UnreturnedInvestmentCapMil' },
    //{ data: 'NetAssetValueMil' },
    //{ data: 'FeePercentCommitment' },
    //{ data: 'FeePercentInvestedCap' },
    //{ data: 'FeeBasisDuringCommitmentTypeName', type: 'dropdown', source: ['', 'Commitment Amount', 'Net Asset Value', 'Book Cost', 'Unreturned Invested Capital', 'Net Operating Income', 'Other'] },
    //{ data: 'FeeBasisPostCommitmentTypeName', type: 'dropdown', source: ['', 'Commitment Amount', 'Net Asset Value', 'Book Cost', 'Unreturned Invested Capital', 'Net Operating Income', 'Other'] },
    //{ data: 'CarriedInterestPercent' },
    //{ data: 'HurdleRatePercent' },
    //{ data: 'RowID' },
    //{ data: 'del' },

    
    return [dataObj, listOfHeaderRows, referenceToTable];
}